
<template>

	<mymodal ref="modal" title="Обобщенные значения" without_ok :reset="reset">

		<div class="mb-2">Количеством объектов со значением: {{ not_empty_count }}</div>
		<div class="mb-2">Количеством объектов с пустым значением: {{ empty_count }}</div>

        <b-table v-if="items" :fields="fields" :items="items" />

	</mymodal>

</template>

<script>

import api from "../../../../../../api"
import mymodal from "../../../../../widgets/modal"

export default
{
	components :
	{
		mymodal,
	},

	data()
	{
		return {
            fields : [
                { key : "value", label : "Значение" },
                { key : "count", label : "Количество объектов" }
            ],

            items : null,
			not_empty_count : null,
			empty_count : 0
		}
	},

	methods :
	{
		reset()
		{
			this.items = null
			this.not_empty_count = null
			this.empty_count = 0
		},

		execute(values, not_empty_count)
		{
			this.$refs.modal.execute()

			this.not_empty_count = not_empty_count

			const _items = []

			values.forEach((value) => {
				if (api.is_empty(value[0]))
				{
					this.empty_count = value[1]
				}
				else
				{
					_items.push({ value : value[0], count : value[1] })
				}
			})

			this.items = _items
		},
	}
}

</script>
